<script setup>
defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['xs', 'sm', 'md', 'lg'].includes(v),
  },
})
</script>

<template>
  <span
    :class="[$style['spinner'], size && $style[`spinner--${size}`]]"
    role="status"
    aria-label="Laden..."
  />
</template>

<style module>
.spinner {
  display: inline-block;
  border-radius: 50%;
  border: 2px solid var(--opacity-surface-state-2);
  border-top-color: var(--primary-color);
  animation: spin 0.75s linear infinite;
  width: var(--spacing-xl);
  height: var(--spacing-xl);
}

.spinner--xs {
  width: var(--spacing);
  height: var(--spacing);
  border-width: 1px;
}

.spinner--sm {
  width: var(--spacing-l);
  height: var(--spacing-l);
  border-width: 1px;
}

.spinner--lg {
  width: var(--spacing-xxxl);
  height: var(--spacing-xxxl);
  border-width: 3px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
